import type {
  ArtifactCapabilitiesResponseApi,
  ArtifactComponentTypeCapabilitiesApi,
} from '@ingenico/api-sdk-device-management-private-v2';
import {
  RESOURCE_ARTIFACT_DEFAULT_CAPABILITIES,
  type ResourceArtifactCapabilitiesFront,
} from '../../models/resources.model';
import { parseResourceMaxFileSize, toResourceFileExtensions } from '../../../utils/resourceArtifactCapabilities.util';

export function mapResourceArtifactCapabilities(
  response: ArtifactCapabilitiesResponseApi,
): ResourceArtifactCapabilitiesFront {
  const capability = response.upload.componentTypes.find(
    (item: ArtifactComponentTypeCapabilitiesApi) => item.componentType === 'RESOURCE',
  );

  if (!capability) {
    return RESOURCE_ARTIFACT_DEFAULT_CAPABILITIES;
  }

  const fileExtensions = toResourceFileExtensions(capability.supportedFileTypes);
  const maxFileSize = parseResourceMaxFileSize(capability.supportedFileTypes);

  return {
    fileExtensions: fileExtensions.length > 0 ? fileExtensions : RESOURCE_ARTIFACT_DEFAULT_CAPABILITIES.fileExtensions,
    ...maxFileSize,
  };
}
